import { render, staticRenderFns } from "./AttributesForm.vue?vue&type=template&id=6b741a7b&"
import script from "./AttributesForm.vue?vue&type=script&lang=js&"
export * from "./AttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports